import {
  Button,
  Divider,
  Stack,
  useTheme,
} from '@mui/material';
import React from 'react';
import Icon from './Icon';

function PickupDeliveryInput({
  hasDelivery,
  pickupText = 'Pickup',
  deliveryText = 'Delivery',
  borderRadius,
  size = 'medium',
  disabled,
  onChange, ...props
}) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  // Helper to determine background color for disabled state
  const getDisabledBgColor = (isSelected, theme) => {
    if (isSelected) return theme.palette.text.secondary;
    return isDarkMode ? theme.palette.background.elevation3 : theme.palette.background.elevation1;
  };

  return (
    <Stack
      divider={<Divider />}
      direction="row"
      sx={{
        backgroundColor: isDarkMode ? 'background.elevation2' : 'grey.100',
        borderRadius: 2,
      }}
      gap={size === 'small' ? 0 : 0.75}
      {...props}
    >
      <Button
        startIcon={<Icon name="motor-outlined" />}
        variant={hasDelivery ? 'primary' : 'secondary'}
        size={size}
        fullWidth
        onClick={() => onChange(true)}
        sx={(theme) => ({
          borderRadius,
          fontSize: size === 'small' ? 12 : undefined,
          ...(isDarkMode && !hasDelivery && {
            backgroundColor: theme.palette.background.elevation3,
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: theme.palette.background.elevation3,
              opacity: 0.9,
            },
          }),
          '&:disabled': {
            backgroundColor: getDisabledBgColor(hasDelivery, theme),
            color: hasDelivery ? theme.palette.text.white : theme.palette.text.disabled,
          },
        })}
        loading={hasDelivery}
        disabled={disabled}
        endIcon={hasDelivery && <Icon name="checkmark" />}
      >
        {deliveryText}
      </Button>
      <Button
        startIcon={<Icon name="walk-filled" />}
        variant={!hasDelivery ? 'primary' : 'secondary'}
        size={size}
        fullWidth
        onClick={() => onChange(false)}
        sx={(theme) => ({
          borderRadius,
          fontSize: size === 'small' ? 12 : undefined,
          ...(isDarkMode && hasDelivery && {
            backgroundColor: theme.palette.background.elevation3,
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: theme.palette.background.elevation3,
              opacity: 0.9,
            },
          }),
          '&:disabled': {
            backgroundColor: getDisabledBgColor(!hasDelivery, theme),
            color: !hasDelivery ? theme.palette.text.white : theme.palette.text.disabled,
          },
        })}
        loading={!hasDelivery}
        disabled={disabled}
        endIcon={!hasDelivery && <Icon name="checkmark" />}
      >
        {pickupText}
      </Button>
    </Stack>
  );
}

export default PickupDeliveryInput;
